import React, { useState } from "react";
import { Button, Row, Col, Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import _fetch from "../../_fetch";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/loader";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AddressForm from "../Subscription/AddressForm";
import { getUserData, LoginAction } from "../../actions/userActions";
import CheckoutFormCart from "../Cart/CheckoutFormCart";
const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function Payment({ orders, setOrder }) {
    console.log("Payment Orders:", orders);
    const { stripeAddress } = useSelector(st => st.user);
    const [clientSecret, setClientSecret] = useState("");
    const [amount, setAmount] = useState({});
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [elementType, setElementType] = useState(0);
    const dispatch = useDispatch();
    const handleStripeCheckout = async (orders) => {
    try {
        console.log("Order data:", orders);
        const order = orders;  
        let res = await _fetch(`${process.env.REACT_APP_API_V2}/stripe-payment/orders`, {
            method: 'POST',
            body: {
                invoice_id: order.invoice_id,
                invoice_total: order.invoice_total,
                currency: "gbp",
                type:"EXTENSION"
            },
        });
        if (res.success) {
            setClientSecret(res.response.clientSecret);
            setAmount(res.response.net_amount);
            setElementType(1);
            setModalVisible(true);
        } else {
            toast.error(res.response);
        }

    } catch (err) {
        console.error("Stripe Checkout error:", err);
        alert("Something went wrong while processing payment.");
    }
};
    const createStripeUser = async (address) => {
            try {
                setLoading(true);
                if (!address) return toast.error('Please enter your address!');
                let url = `${process.env.REACT_APP_API_V2}/stripe-payment/customer`;
                let res = await _fetch(url, {
                    method: 'POST',
                    body: {
                        address: address,
                    },
                });
                if (res.success) {
                    await handleStripeCheckout(orders);
                    let data = await getUserData();
                        if (data) {
                            dispatch(LoginAction(data));
                        } 
                } else {
                    toast.error(res.response);
                }
            } catch (err) {
                console.log(err);
                toast.error('Something went wrong!');
            } finally {
                setLoading(false);
            }
        };


    if(!orders) return null;

    return (
        <>
        {modalVisible && (
				<Modal
					isOpen={modalVisible}
					toggle={() => {
						setModalVisible(false);
						setElementType(0);
						setClientSecret('');
					}}
					style={{
						maxWidth: '450px',
					}}
				>
					<ModalHeader
						toggle={() => {
							setModalVisible(false);
							setElementType(0);
							setClientSecret('');
						}}
					>
						Subscribe
					</ModalHeader>
					<ModalBody>
						{loading ? (
							<div className='w-100 h-100 d-flex justify-content-center align-items-center'>
								<Loader />
							</div>
						) : (
							<div>
								{elementType === 0 && (
									<Elements stripe={stripe}>
										<AddressForm onSubmit={createStripeUser} />
									</Elements>
								)}
								{elementType === 1 && (
									<Elements
										stripe={stripe}
										options={{
											clientSecret: clientSecret,
										}}
									>
										<CheckoutFormCart amount={amount} />
									</Elements>
								)}
							</div>
						)}
					</ModalBody>
				</Modal>
			)}
        <Modal isOpen={true} toggle={() => setOrder(null)}>
            <ModalHeader>
                Enrollment Extension Summary
            </ModalHeader>

            <ModalBody className="bg-secondary shadow h-100">

                <Row>
                    <Col xs={7} md={8} className="text-dark">
                        {orders.extension?.title}
                    </Col>
                    <Col xs={5} md={4} className='font-weight-600'>£{orders.invoice_total / 100}</Col>
                </Row>
                <hr className="my-4" />

                <Row>
                    <Col xs={{ size: 8, offset: 2 }}>
                        <Button type='button' color='primary' className='w-100' onClick={() => {
                                 if(stripeAddress) {
                                        handleStripeCheckout(orders);
                                    } else {
                                        setModalVisible(true);
                                        setElementType(0);
                                    }
                            }} >Complete Payment</Button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
        </>
    );
};
